import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-[#0071bd] text-white text-center py-2">
            <p className="font-bold"> © 2026 All Rights Reserved - Guvvala Sagar Reddy</p>
            <p></p>  <br />
        </footer>
    );
};

export default Footer;